import React, {useEffect, useState} from "react";
import {Button, Card, Col, Divider, Empty, Popconfirm, Row, Select, Tabs, Tooltip} from "antd";
import * as Setting from "../../conf/Setting";
import * as OrganizationBackend from "../../services/OrganizationBackend";
import "./SyncerManagement.less";
import * as SyncerBackend from "../../services/SyncerBackend";
import i18next from "i18next";
import * as IconFont from "../../components/common/IconFont";
import {InfoCircleTwoTone} from "@ant-design/icons";

const {TabPane} = Tabs;
const {Option} = Select;

const SyncerManagement = (props) => {
  const [organizations, setOrganizations] = useState([]);
  const [upstreamSyncers, setUpstreamSyncers] = useState([]);
  const [downstreamSyncers, setDownstreamSyncers] = useState([]);
  const [selectedOrg, setSelectedOrg] = useState("");
  const [currentTab, setCurrentTab] = useState("upstream");

  useEffect(() => {
    OrganizationBackend.getOrganizations(Setting.Admin)
      .then((res) => {
        if (res.msg === undefined) {
          const orgs = res.filter(organization => !Setting.isAdminOrganization(organization.uid)).reverse();
          setOrganizations(orgs);
        }
      });
  }, []);

  useEffect(() => {
    getSyncer();
  }, [currentTab, selectedOrg]);

  const sortSyncers = () => {
    props.history.push({pathname: "/syncers/upstream/order"});
  };

  const addSyncer = () => {
    if (currentTab === "upstream") {
      props.history.push({pathname: "/syncers/upstream/add"});
    } else {
      props.history.push({pathname: "/syncers/downstream/add"});
    }
  };

  const getSyncer = () => {
    if (currentTab === "upstream") {
      SyncerBackend.getUpstreamSyncerByOwner(selectedOrg)
        .then(res => {
          if (res.status === "ok") {
            setUpstreamSyncers(res.data);
          }
        });
    } else {
      SyncerBackend.getDownstreamSyncerByOwner(selectedOrg)
        .then(res => {
          if (res.status === "ok") {
            setDownstreamSyncers(res.data);
          }
        });
    }
  };

  const deleteSyncer = (syncer) => {
    if (currentTab === "upstream") {
      SyncerBackend.deleteUpstreamSyncer(syncer)
        .then((res) => {
          if (res.status === "ok") {
            Setting.showMessage("success", i18next.t("syncer:Syncer deleted successfully"));
            getSyncer();
          } else {
            Setting.showResponseMessage(res.msg);
          }
        }
        )
        .catch(error => {
          Setting.showResponseMessage(error);
        });
    } else {
      SyncerBackend.deleteDownstreamSyncer(syncer)
        .then((res) => {
          if (res.status === "ok") {
            Setting.showMessage("success", i18next.t("syncer:Syncer deleted successfully"));
            getSyncer();
          } else {
            Setting.showResponseMessage(res.msg);
          }
        }
        )
        .catch(error => {
          Setting.showResponseMessage(error);
        });
    }
  };

  const enableSyncer = (syncer, enable) => {
    if (currentTab === "upstream") {
      SyncerBackend.updateUpstreamSyncer(syncer.uid, syncer.owner, {...syncer, isEnabled: enable})
        .then((res) => {
          if (res.status === "ok") {
            if (enable) {
              Setting.showMessage("success", i18next.t("syncer:Enabeld successfully"));
            } else {
              Setting.showMessage("success", i18next.t("syncer:Disabled successfully"));
            }
            getSyncer();
          } else {
            Setting.showResponseMessage(res.msg);
          }
        }
        )
        .catch(error => {
          Setting.showResponseMessage(error);
        });
    } else {
      SyncerBackend.updateDownstreamSyncer(syncer.uid, syncer.owner, {...syncer, isEnabled: enable})
        .then((res) => {
          if (res.status === "ok") {
            if (enable) {
              Setting.showMessage("success", i18next.t("syncer:Enabeld successfully"));
            } else {
              Setting.showMessage("success", i18next.t("syncer:Disabled successfully"));
            }
            getSyncer();
          } else {
            Setting.showResponseMessage(res.msg);
          }
        }
        )
        .catch(error => {
          Setting.showResponseMessage(error);
        });
    }
  };

  const doSync = (syncerId, owner) => {
    SyncerBackend.doUpstreamSync(syncerId, owner)
      .then((res) => {
        if (res.status === "ok") {
          Setting.showMessage("success", i18next.t("syncer:Syncer sync successfully"));
        } else {
          Setting.showResponseMessage(res.msg);
        }
      })
      .catch(error => {
        Setting.showResponseMessage(error);
      });
  };

  const getSyncTypeName = (syncType) => {
    const syncTypeObj = currentTab === "upstream" ? Setting.upstreamSyncTypes.find(item => item.id === syncType) :
      Setting.downstreamSyncTypes.find(item => item.id === syncType);
    if (syncTypeObj) {
      return syncTypeObj.name;
    }
    return "";
  };

  const getSyncTypeTootip = (syncType) => {
    const syncTypeObj = currentTab === "upstream" ? Setting.upstreamSyncTypesTooltip.find(item => item.id === syncType) :
      Setting.downstreamSyncTypesTooltip.find(item => item.id === syncType);
    if (syncTypeObj) {
      return syncTypeObj.name;
    }
    return "";
  };

  const getSyncTypeIcon = (syncType) => {
    switch (syncType) {
    case 0:
      return <IconFont.UserFilledIcon style={{fontSize: 16, color: "#2D78D5", fontWeight: 600}} />;
    case 1:
      return <IconFont.OrganizationFilledIcon style={{fontSize: 16, color: "#13B184", fontWeight: 600}} />;
    case 2:
      return <IconFont.StructureFilledIcon style={{fontSize: 16, color: "#E98C1A", fontWeight: 600}} />;
    case 3:
      return <IconFont.UserRoleIcon style={{fontSize: 16, color: "#E98C1A", fontWeight: 600}} />;
    default:
      return null;
    }
  };

  const renderCard = (syncer) => {
    return (
      <Col key={syncer.uid} style={{paddingLeft: "12px", paddingRight: "12px", paddingBottom: "20px"}} span={6}>
        <Card
          className="syncer-card"
          hoverable
          onClick={() => {
            if (currentTab === "upstream") {
              props.history.push(`/syncers/upstream/${syncer.owner}/${syncer.uid}`);
            } else {
              props.history.push(`/syncers/downstream/${syncer.owner}/${syncer.uid}`);
            }
          }}
        >
          <div style={{paddingLeft: 17, marginBottom: 20, display: "flex", justifyContent: "space-between", position: "relative"}}>
            <img style={{position: "absolute", left: 0, top: 0}} src={require("../../assets/images/syncer/rect.png")} />
            <div style={{width: currentTab === "upstream" ? "calc(100% - 88px)" : "calc(100% - 20px)", display: "flex"}}>
              <div title={syncer.displayName}
                style={{overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "calc(100% - 60px)", fontSize: 14, fontWeight: 600, color: "rgba(0, 0, 0, 0.85)"}}>
                {syncer.displayName}
              </div>
              {
                !syncer.isEnabled ?
                  <span style={{marginLeft: 8, backgroundColor: "#D4D4D4", width: 58, fontSize: 12, padding: "2px 8px", borderRadius: 50, textAlign: "center", color: "rgba(0, 0, 0, 0.45)"}}>
                    {i18next.t("syncer:Disabled")}
                  </span>
                  :
                  null
              }
            </div>
            {
              currentTab === "upstream" ?
                <div style={{marginRight: 10, color: "rgba(0, 0, 0, 0.45)"}}>
                  <img src={require("../../assets/images/syncer/diamond.png")} style={{marginRight: 3}} />
                  {i18next.t("syncer:Priority")}
                  {syncer.order}
                </div>
                :
                null
            }
          </div>
          <div style={{height: 32, paddingLeft: 17, display: "flex", justifyContent: "space-between", alignItems: "center"}}>
            <div style={{color: "rgba(0, 0, 0, 0.65)"}}>
              {
                getSyncTypeIcon(syncer.syncType)
              }
              &nbsp;&nbsp;
              {
                getSyncTypeName(syncer.syncType)
              }
              <Tooltip placement="top" title={getSyncTypeTootip(syncer.syncType)}>
                <InfoCircleTwoTone twoToneColor="rgb(45, 120, 213)" style={{marginLeft: 4}} />
              </Tooltip>
            </div>
            <div>
              {
                currentTab === "upstream" && syncer.isEnabled ?
                  <>
                    <Popconfirm
                      title={`${i18next.t("syncer:Sure to sync")}`}
                      onCancel={(e) => {
                        e.stopPropagation();
                      }}
                      onConfirm={(e) => {
                        e.stopPropagation();
                        doSync(syncer.uid, syncer.owner);
                      }}
                      disabled={false}
                    >
                      <Button style={{color: "#2D78D5", paddingLeft: 5, paddingRight: 5}} type="link" onClick={(e) => e.stopPropagation()}>{i18next.t("syncer:Sync")}</Button>
                    </Popconfirm>
                    <Divider type="vertical" style={{margin: 0}} />
                  </>
                  :
                  null
              }
              {
                currentTab === "upstream" ?
                  <>
                    <Button style={{color: "#2D78D5", paddingLeft: 5, paddingRight: 5}} type="link" onClick={(e) => {
                      e.stopPropagation();
                      props.history.push({pathname: `/syncers/upstream/${syncer.owner}/${syncer.uid}`, tabMode: "log"});
                    }}>{i18next.t("syncer:Log")}
                    </Button>
                    <Divider type="vertical" style={{margin: 0, color: "#D8D8D8"}} />
                  </>
                  :
                  null
              }
              {
                syncer.isEnabled ?
                  <Popconfirm
                    title={`${i18next.t("syncer:Sure to disable syncer")}`}
                    onCancel={(e) => {
                      e.stopPropagation();
                    }}
                    onConfirm={(e) => {
                      e.stopPropagation();
                      enableSyncer(syncer, false);
                    }}
                    disabled={false}
                  >
                    <Button style={{color: "#ff4d4f", paddingLeft: 5, paddingRight: 5}} type="link" onClick={(e) => e.stopPropagation()}>{i18next.t("syncer:Disable")}</Button>
                  </Popconfirm>
                  :
                  <>
                    <>
                      <Popconfirm
                        title={`${i18next.t("syncer:Sure to enable syncer")}`}
                        onCancel={(e) => {
                          e.stopPropagation();
                        }}
                        onConfirm={(e) => {
                          e.stopPropagation();
                          enableSyncer(syncer, true);
                        }}
                        disabled={false}
                      >
                        <Button style={{color: "#2D78D5", paddingLeft: 5, paddingRight: 5}} type="link" onClick={(e) => e.stopPropagation()}>{i18next.t("syncer:Enable")}</Button>
                      </Popconfirm>
                      <Divider type="vertical" style={{margin: 0}} />
                    </>
                    <Popconfirm
                      title={`${i18next.t("syncer:Sure to delete syncer")}`}
                      onCancel={(e) => {
                        e.stopPropagation();
                      }}
                      onConfirm={(e) => {
                        e.stopPropagation();
                        deleteSyncer(syncer);
                      }}
                      disabled={false}
                    >
                      <Button style={{color: "#ff4d4f", paddingLeft: 5, paddingRight: 5}} type="link" onClick={(e) => e.stopPropagation()}>{i18next.t("syncer:Delete")}</Button>
                    </Popconfirm>
                  </>
              }
            </div>
          </div>
        </Card>
      </Col>
    );
  };

  return (
    <>
      <Tabs tabBarExtraContent={<div>
        <Select virtual={false} style={{width: 150, marginRight: 10}}
          value={selectedOrg}
          onChange={(value => {
            setSelectedOrg(value);
          })}>
          <Option value={""}>{i18next.t("syncer:All")}</Option>
          {
            organizations.map((organization, index) => <Option key={index} value={organization.uid}>{organization.displayName}</Option>)
          }
        </Select>
        <Button type="primary" onClick={addSyncer} style={{marginRight: 10}}>{i18next.t("syncer:Add")}</Button>
        {
          currentTab === "upstream" ?
            <Button type="default" onClick={sortSyncers}>{i18next.t("syncer:Sort")}</Button>
            :
            null
        }
      </div>}
      onChange={(activeKey) => {
        setCurrentTab(activeKey);
      }}
      >
        <TabPane tab={i18next.t("syncer:Upstream list")} key="upstream">
          <div style={{marginRight: "15px", marginLeft: "15px"}}>
            {
              upstreamSyncers.length > 0 ?
                <Row justify="flex-start" style={{marginLeft: "-20px", marginRight: "-20px", marginTop: "20px"}} gutter={24}>
                  {
                    upstreamSyncers.map((syncer, index) => renderCard(syncer))
                  }
                </Row>
                :
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            }
          </div>
        </TabPane>
        <TabPane tab={i18next.t("syncer:Downstream list")} key="downstream">
          <div style={{marginRight: "15px", marginLeft: "15px"}}>
            {
              downstreamSyncers.length > 0 ?
                <Row justify="flex-start" style={{marginLeft: "-20px", marginRight: "-20px", marginTop: "20px"}} gutter={24}>
                  {
                    downstreamSyncers.map((syncer, index) => renderCard(syncer))
                  }
                </Row>
                :
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            }
          </div>
        </TabPane>
      </Tabs>
    </>
  );
};

export default SyncerManagement;
